<homey-header ngSkipHydration class="sticky z-20 top-0"/>
<p-toast></p-toast>
<p-confirm-dialog/>
<main class="flex-1 flex justify-center text-color relative" [ngClass]="mainBgClass()" xmlns="http://www.w3.org/1999/html">
  <div
    class="w-full max-w-md md:max-w-lg px-pagePadX thin:px-pagePadXSmall py-pagePadY flex flex-col relative"
    [ngClass]="innerClass()">
    @if (!initialDataLoaded() && !wasPrerendered) {
      <div class="h-full flex-grow flex items-center justify-center">
        <p-progress-spinner/>
      </div>
    }
    <router-outlet></router-outlet>
  </div>
</main>

<p-dialog [modal]="true" [closable]="false" [header]="paymentService.pastDueDialogHeader()" [visible]="paymentService.pastDueRecoveryStep() !== 'not-started'">
  <p>{{paymentService.pastDueDescription()}}</p>


  <div class="mt-4 flex flex-row justify-center">
    @if(paymentService.pastDueRecoveryStep() === 'success' || paymentService.pastDueRecoveryStep() === 'retry-failed') {
      <p-button size="small" (onClick)="paymentService.resetPastDueDialog()">Continue</p-button>
    } @else {
      <p-progress-spinner/>
    }
  </div>


</p-dialog>

<homey-drawer-outlet/>
